import React, { useState } from "react";
import { Link } from "react-router-dom";

import { Button, Image, Modal, Icon } from "semantic-ui-react";
import { Container, Img, Div } from "./styles";

function Card({ nome, img, menssage }) {
  const [modal, setModal] = useState(false);


  const modifyMenssage = (mensagem) => {
    let hora = 0;
    let data = 0;
    let newArray = mensagem.data.split('T');
    data = newArray[0];
    newArray = newArray[1].split('.');
    hora = newArray[0];
    if (mensagem.menssage.indexOf('{') == -1) {
      return `${mensagem.menssage} em ${data} às ${hora}`
    } else {
      const mensagemJson = JSON.parse(mensagem.menssage);
      return `${mensagemJson.texto} na página ${mensagemJson.local} em ${data} às ${hora}`
    }
  }
  return (
    <Container>
      <header>
        <div>
          <Img src={img} alt="Imagem do corpo" /> {nome}
        </div>
      </header>

      <footer>
        <Button color="secondary" onClick={() => setModal(!modal)}>Mostrar</Button>
      </footer>
      <Modal
        size='large'
        open={modal}
        onClose={() => setModal(false)}
        onOpen={() => setModal(true)}
      >
        <Modal.Header>{nome}</Modal.Header>
        <Modal.Content image scrolling>
          <Modal.Description>
            {
              menssage.map(value => (
                <Div>{modifyMenssage(value)}</Div>
              ))
            }
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setModal(false)} primary>
            Fechar <Icon name='chevron right' />
          </Button>
        </Modal.Actions>
      </Modal>
    </Container>
  );
}

export default Card;
